// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b0411337","453":"d158e4fb","455":"f24f83c7","977":"3c287974"}[chunkId] + ".chunk.js";
};